// @flow
const ENVIRONMENT: ('production' | 'staging' | 'development') =
  location.hostname === 'bogintra.dk'
    ? 'production'
    : location.hostname === 'next.bogintra.dk'
      ? 'staging'
      : 'development';

export { ENVIRONMENT };
